import * as React from "react";
import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import { isChecked } from "src/common/groupChecked";
import { Planning2Column } from "../Planning2Table/Planning2Column";
import { Planning2GanttStore } from "./Planning2GanttStore";
import { ZPlanning2Row } from "../../ZPlanning2Row";
import { Planning2NameCell } from "./Planning2NameCell/Planning2NameCell";

export const buildLeftColumns = (
  srcColumns: Planning2Column[],
  gantt: Planning2GanttStore,
): Planning2Column[] => [
  {
    key: "@selection",
    title: <SelectAll gantt={gantt} />,
    width: 34,
    render: (_, row) => <SelectRow gantt={gantt} row={row} />,
  },
  {
    key: "name",
    title: srcColumns[0]?.title ?? "Name",
    width: srcColumns[0]?.width ?? 400,
    render: (_, row) => <Planning2NameCell gantt={gantt} row={row} />,
  },
  ...srcColumns.slice(1),
];

type PropsSelectAll = {
  gantt: Planning2GanttStore;
};

const SelectAll: React.FC<PropsSelectAll> = observer(({ gantt }) => {
  const { selectedAll } = gantt.tableStore;
  return (
    <Checkbox
      checked={isChecked(selectedAll)}
      indeterminate={selectedAll === "partial"}
      onChange={() => gantt.tableStore.toggleAllSelection()}
    />
  );
});

type PropsSelectRow = {
  gantt: Planning2GanttStore;
  row: ZPlanning2Row;
};

const SelectRow: React.FC<PropsSelectRow> = observer((props) => {
  const { gantt, row } = props;
  const { tableStore } = gantt;
  const { selectedGroups, selectedTasks } = tableStore;
  if (row.kind === "group") {
    const selected = selectedGroups[row.id];
    return (
      <Checkbox
        checked={isChecked(selected)}
        indeterminate={selected === "partial"}
        onChange={() => tableStore.toggleGroupSelection(row.id)}
      />
    );
  }
  return (
    <Checkbox
      checked={selectedTasks.has(row.id)}
      onClick={() => tableStore.toggleTaskSelection(row.id)}
    />
  );
});
